<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import TypographyItem from '@/components/Typography/TypographyItem.vue'
</script>

<template>
    <StackLayout direction="column" :gap="8">
        <TypographyItem bold :label="$t('device.updateVersion.stepOne.title')" />
        <TypographyItem :label="$t('device.updateVersion.stepOne.firstLine')" />
        <TypographyItem :label="$t('device.updateVersion.stepOne.secondLine')" />

        <ul class="step-one-list">
            <li><TypographyItem :label="$t('device.updateVersion.stepOne.firstRule')" /></li>
            <li><TypographyItem :label="$t('device.updateVersion.stepOne.secondRule')" /></li>
            <li><TypographyItem :label="$t('device.updateVersion.stepOne.thirdRule')" /></li>
            <li><TypographyItem :label="$t('device.updateVersion.stepOne.fourthRule')" /></li>
            <li><TypographyItem :label="$t('device.updateVersion.stepOne.fifthRule')" /></li>
        </ul>
    </StackLayout>
</template>

<style scoped lang="scss">
.step-one-list {
    margin-left: 2em;
    list-style-type: disc;
}
</style>
